import { ReactElement } from 'react';
import { ReactComponent as GlobeIcon } from '~/ui/assets/images/global.svg';

import hasGlobalUserRoleInClinic from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/helpers/hasGlobalUserRoleInClinic';
import { AllocationRole } from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/model/types';

import variables from '~/ui/assets/styles/colors.module.scss';

import styles from './TeamMemberAccordion.module.scss';

interface IProps {
  roles: AllocationRole[] | undefined;
  clinicId: string;
}

const GlobalUserBadge = ({ roles, clinicId }: IProps): ReactElement | null => {
  if (!hasGlobalUserRoleInClinic(roles, clinicId)) {
    return null;
  }

  return (
    <div className={styles.absoluteIcon}>
      <GlobeIcon width={16} height={16} color={variables.colorGreenGlobal} />
    </div>
  );
};

export default GlobalUserBadge;
